"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonStyled = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var colors_1 = require("../../themes/colors");
var mixins_1 = require("../../themes/mixins");
var utilsOolib_1 = require("../../utilsOolib");
var greyColor100 = colors_1.colors.greyColor100, greyColor90 = colors_1.colors.greyColor90, greyColor80 = colors_1.colors.greyColor80, greyColor70 = colors_1.colors.greyColor70, greyColor15 = colors_1.colors.greyColor15, greyColor40 = colors_1.colors.greyColor40, greyColor10 = colors_1.colors.greyColor10, white = colors_1.colors.white, none = colors_1.colors.none;
//sizes
var SIZES = {
    S: "3rem",
    M: "4rem",
};
var hoverStylingPrimary = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n background-color: ", ";\n color: ", ";\n"], ["\n background-color: ", ";\n color: ", ";\n"])), function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? (0, utilsOolib_1.getPrimaryColor10)(colors)
        : (0, utilsOolib_1.getPrimaryColor40)(colors);
}, function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? greyColor100
        : (0, utilsOolib_1.getPrimaryColorText)(colors);
});
var hoverStylingSecondary = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n background-color: ", ";\n"], ["\n background-color: ", ";\n"])), function (_a) {
    var invert = _a.invert, active = _a.active, colors = _a.theme.colors;
    return active
        ? ""
        : invert
            ? greyColor80
            : (0, utilsOolib_1.getPrimaryColor40)(colors);
});
var hoverStylingCustom = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n background-color: ", ";\n"], ["\n background-color: ", ";\n"])), function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? greyColor80
        : (0, utilsOolib_1.getPrimaryColor40)(colors);
});
var hoverStylingGhost = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n background-color: ", ";\n"], ["\n background-color: ", ";\n"])), function (_a) {
    var invert = _a.invert, active = _a.active;
    return active
        ? ""
        : invert
            ? greyColor80
            : greyColor10;
});
var ButtonPrimary = (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n border: none;\n background-color: ", ";\n color: ", ";\n ", "\n ", "\n\n ", "  \n \n @media (hover: hover) {\n   &:hover {\n     ", "\n   }\n }\n"], ["\n border: none;\n background-color: ", ";\n color: ", ";\n ", "\n ", "\n\n ", "  \n \n @media (hover: hover) {\n   &:hover {\n     ", "\n   }\n }\n"])), function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? (0, utilsOolib_1.getPrimaryColor40)(colors)
        : (0, utilsOolib_1.getPrimaryColor100)(colors);
}, function (_a) {
    var invert = _a.invert;
    return invert ? greyColor100 : white;
}, function (_a) {
    var color = _a.color;
    return color && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n     color: ", ";\n   "], ["\n     color: ", ";\n   "])), color);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n     background-color: ", ";\n     color: ", ";\n     pointer-events: none;\n   "], ["\n     background-color: ", ";\n     color: ", ";\n     pointer-events: none;\n   "])), function (_a) {
        var invert = _a.invert;
        return invert ? greyColor70 : greyColor15;
    }, greyColor40);
}, function (_a) {
    var forceHover = _a.forceHover;
    return forceHover && hoverStylingPrimary;
}, hoverStylingPrimary);
var ButtonSecondary = (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n border: 2px solid\n   ", ";\n background-color: ", ";\n\n color: ", "; \n ", "\n ", "\n ", "\n\n   ", "  \n\n   @media (hover: hover) {\n     &:hover {\n       ", "\n   }\n }\n"], ["\n border: 2px solid\n   ", ";\n background-color: ", ";\n\n color: ", "; \n ", "\n ", "\n ", "\n\n   ", "  \n\n   @media (hover: hover) {\n     &:hover {\n       ", "\n   }\n }\n"])), function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? (0, utilsOolib_1.getPrimaryColor40)(colors)
        : (0, utilsOolib_1.getPrimaryColor100)(colors);
}, function (_a) {
    var invert = _a.invert;
    return invert ? greyColor100 : white;
}, function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? (0, utilsOolib_1.getPrimaryColor40)(colors)
        : (0, utilsOolib_1.getPrimaryColorText)(colors);
}, function (_a) {
    var color = _a.color;
    return color && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n     color: ", ";\n   "], ["\n     color: ", ";\n   "])), color);
}, function (_a) {
    var active = _a.active;
    return active && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n     background-color: ", ";\n     color: ", ";\n   "], ["\n     background-color: ", ";\n     color: ", ";\n   "])), function (_a) {
        var invert = _a.invert, colors = _a.theme.colors;
        return invert ?
            (0, utilsOolib_1.getPrimaryColor40)(colors)
            :
                (0, utilsOolib_1.getPrimaryColor10)(colors);
    }, function (_a) {
        var colors = _a.theme.colors;
        return (0, utilsOolib_1.getPrimaryColorText)(colors);
    });
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n     background-color: ", ";\n     border: 2px solid ", ";\n     color: ", "; \n     pointer-events: none;\n   "], ["\n     background-color: ", ";\n     border: 2px solid ", ";\n     color: ", "; \n     pointer-events: none;\n   "])), function (_a) {
        var invert = _a.invert;
        return invert ? greyColor80 : white;
    }, greyColor15, greyColor40);
}, function (_a) {
    var forceHover = _a.forceHover;
    return forceHover && hoverStylingSecondary;
}, hoverStylingSecondary);
var ButtonCustom = (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n border: 2px solid\n   ", ";\n box-shadow: -4px 4px 1px\n   ", ";\n   \n background-color: ", ";\n\n color: ", ";\n\n ", "\n\n ", "\n\n ", "  \n\n @media (hover: hover) {\n   &:hover {\n     ", "\n   }\n }\n"], ["\n border: 2px solid\n   ", ";\n box-shadow: -4px 4px 1px\n   ", ";\n   \n background-color: ", ";\n\n color: ", ";\n\n ", "\n\n ", "\n\n ", "  \n\n @media (hover: hover) {\n   &:hover {\n     ", "\n   }\n }\n"])), function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? (0, utilsOolib_1.getPrimaryColor40)(colors)
        : (0, utilsOolib_1.getPrimaryColor100)(colors);
}, function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? (0, utilsOolib_1.getPrimaryColor40)(colors)
        : (0, utilsOolib_1.getPrimaryColor100)(colors);
}, function (_a) {
    var invert = _a.invert;
    return invert ? greyColor100 : white;
}, function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert
        ? (0, utilsOolib_1.getPrimaryColor40)(colors)
        : (0, utilsOolib_1.getPrimaryColorText)(colors);
}, function (_a) {
    var color = _a.color;
    return color && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["color: ", ";"], ["color: ", ";"])), color);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n     color: ", ";\n     border: 2px solid ", "; // $darkShadowColor : $greyColor15;\n     box-shadow: -4px 4px 1px ", ";\n     pointer-events: none;\n     background-color: ", "; \n   "], ["\n     color: ", ";\n     border: 2px solid ", "; // $darkShadowColor : $greyColor15;\n     box-shadow: -4px 4px 1px ", ";\n     pointer-events: none;\n     background-color: ", "; \n   "])), greyColor40, function (_a) {
        var invert = _a.invert;
        return (invert ? greyColor40 : greyColor15);
    }, greyColor40, function (_a) {
        var invert = _a.invert;
        return invert ? greyColor80 : white;
    });
}, function (_a) {
    var forceHover = _a.forceHover;
    return forceHover && hoverStylingCustom;
}, hoverStylingCustom);
var ButtonGhost = (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n background-color: ", ";\n color: ", ";\n ", "\n ", "\n\n ", "\n \n ", "  \n \n @media (hover: hover) {\n   &:hover {\n     ", "\n   }\n }\n"], ["\n background-color: ", ";\n color: ", ";\n ", "\n ", "\n\n ", "\n \n ", "  \n \n @media (hover: hover) {\n   &:hover {\n     ", "\n   }\n }\n"])), function (_a) {
    var active = _a.active, colors = _a.theme.colors;
    return active ? (0, utilsOolib_1.getPrimaryColor40)(colors) : none;
}, function (_a) {
    var invert = _a.invert, composition = _a.composition, colors = _a.theme.colors;
    return invert
        ? (0, utilsOolib_1.getPrimaryColor40)(colors)
        : composition === "iconOnly"
            ? greyColor100
            : (0, utilsOolib_1.getPrimaryColorText)(colors);
}, function (_a) {
    var color = _a.color;
    return color && (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n     color: ", ";\n   "], ["\n     color: ", ";\n   "])), color);
}, function (_a) {
    var invert = _a.invert;
    return invert && (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n     background-color: ", ";\n   "], ["\n     background-color: ", ";\n   "])), function (_a) {
        var active = _a.active;
        return active ? greyColor80 : greyColor100;
    });
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n     color: ", "; //$greyColor40;\n     pointer-events: none;\n   "], ["\n     color: ", "; //$greyColor40;\n     pointer-events: none;\n   "])), greyColor40);
}, function (_a) {
    var forceHover = _a.forceHover;
    return forceHover && hoverStylingGhost;
}, hoverStylingGhost);
var GoogleButton = (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n color: #4285f4;\n border: 2px solid #4285f4;\n background-color: ", ";\n ", "\n"], ["\n color: #4285f4;\n border: 2px solid #4285f4;\n background-color: ", ";\n ", "\n"])), white, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n     pointer-events: none;\n   "], ["\n     pointer-events: none;\n   "])));
});
var buttonVariantSetting = {
    primary: ButtonPrimary,
    secondary: ButtonSecondary,
    ghost: ButtonGhost,
    custom: ButtonCustom,
    googleAuth: GoogleButton,
};
exports.ButtonStyled = styled_components_1.default.button(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n ", "\n\n ", "\n\n white-space: nowrap;\n display: flex;\n justify-content: center;\n align-items: center;\n gap: 1rem;\n cursor: pointer;\n border: none;\n border-radius: 2px;\n\n &:disabled {\n   cursor: not-allowed;\n }\n\n ", "\n\n ", "\n"], ["\n ", "\n\n ", "\n\n white-space: nowrap;\n display: flex;\n justify-content: center;\n align-items: center;\n gap: 1rem;\n cursor: pointer;\n border: none;\n border-radius: 2px;\n\n &:disabled {\n   cursor: not-allowed;\n }\n\n ", "\n\n ", "\n"])), function (_a) {
    var composition = _a.composition, size = _a.size;
    switch (composition) {
        case "iconOnly":
            return (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n         padding: 0;\n         height: ", ";\n         width: ", ";\n         flex-shrink: 0; // if button is a flex item then by default it's width shrinks when the viewport width shrinks\n       "], ["\n         padding: 0;\n         height: ", ";\n         width: ", ";\n         flex-shrink: 0; // if button is a flex item then by default it's width shrinks when the viewport width shrinks\n       "])), SIZES[size], SIZES[size]);
        case "icon+text":
            return (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n         padding: 0 2rem 0 1.5rem;\n         height: ", ";\n       "], ["\n         padding: 0 2rem 0 1.5rem;\n         height: ", ";\n       "])), SIZES[size]);
        default:
            return (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n         padding: 0 2rem;\n         height: ", ";\n       "], ["\n         padding: 0 2rem;\n         height: ", ";\n       "])), SIZES[size]);
    }
}, function (_a) {
    var width = _a.width;
    return width && (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n     width: ", ";\n   "], ["\n     width: ", ";\n   "])), width);
}, (0, mixins_1.transition)("background-color"), function (_a) {
    var variant = _a.variant;
    return buttonVariantSetting[variant];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25;
